import { apiGet, apiPatch } from './client';
import type {
  NonQuantoDay,
  NonQuantoDayBatchRequest,
  NonDmf4Fund,
  NonDmf4FundBatchRequest,
} from '../types/NonDays';

// NonQuantoDays is Central (NoTenantContext). NonDmf4Fund is tenant-scoped
// (X-Tenant-Id applied automatically by the client).

export function getNonQuantoDays(): Promise<NonQuantoDay[]> {
  return apiGet<NonQuantoDay[]>('/api/non-quanto-days');
}

export function saveNonQuantoDaysBatch(
  added: NonQuantoDay[],
  modified: NonQuantoDay[],
  deletedIds: number[],
): Promise<NonQuantoDay[]> {
  return apiPatch<NonQuantoDayBatchRequest, NonQuantoDay[]>('/api/non-quanto-days/batch', {
    added,
    modified,
    deleted: deletedIds,
  });
}

export function getNonDmf4Fund(): Promise<NonDmf4Fund[]> {
  return apiGet<NonDmf4Fund[]>('/api/non-dmf-4-fund');
}

export function saveNonDmf4FundBatch(
  added: NonDmf4Fund[],
  modified: NonDmf4Fund[],
  deletedIds: number[],
): Promise<NonDmf4Fund[]> {
  return apiPatch<NonDmf4FundBatchRequest, NonDmf4Fund[]>('/api/non-dmf-4-fund/batch', {
    added,
    modified,
    deleted: deletedIds,
  });
}
